import { RESOURCE, useResourceCapabilities } from "@dashboard/library";
import { SPEAKERS_COLORS } from "@/constants/style.constants";
import { useCall } from "@/hooks/useCall/useCall";

/**
 * Check the permission from dashboard context
 * @returns Whether the connected user has the permission the read a number
 */

export const useHasReadLinePermission = () => {
  const { canRead } = useResourceCapabilities(RESOURCE.CONVERSATIONS_CENTER);
  return canRead;
};

export const useSpeakerColor = (channel: number) => {
  const { call } = useCall();
  const { variant } = call?.speakers?.get?.(channel) ?? { variant: "green" };

  return SPEAKERS_COLORS[variant];
};
